// removed by extract-text-webpack-plugin
module.exports = {"about":"_27VQcXh6wzt08uGx2Y-BZM"};


//////////////////
// WEBPACK FOOTER
// ./src/sections/About/About.css
// module id = 185
// module chunks = 0